import request from '../../../core/wrappers/axios-wrapper';
import { AIPromptQueryUrl } from '../../../types/constants/apiUrls/AIPrompt/AIPromptQuery';
import { RequestType } from '../../../types/enums/request-enums';
import { AIPromptCategory, AIModelType } from '../../../types/enums/ai-prompt-enums';

/**
 * AI Prompt listesi query parametreleri
 */
export interface GetAIPromptsParams {
    category?: AIPromptCategory;
    modelType?: AIModelType;
    isActive?: boolean;
    isSystemPrompt?: boolean;
    page?: number;
    pageSize?: number;
}

/**
 * AI Prompt Response interface
 */
export interface AIPromptResponse {
    id: number;
    name: string;
    code: string;
    category: string;
    modelType: string;
    promptText: string;
    isActive: boolean;
    isSystemPrompt: boolean;
    createdDate: string;
    updatedDate?: string;
    createdBy: string;
    updatedBy?: string;
}

/**
 * AI Prompt listesini getirir (Filtreleme desteği ile)
 * @param params Filtre parametreleri
 * @returns Promise<AIPromptResponse[]>
 */
export const GetAIPrompts = (params?: GetAIPromptsParams) =>
    request({
        url: AIPromptQueryUrl.GetAIPrompts,
        method: RequestType.GET,
        params: params,
    });

/**
 * ID'ye göre AI Prompt detayını getirir
 * @param id Prompt ID
 * @returns Promise<AIPromptResponse>
 */
export const GetAIPromptById = (id: number) =>
    request({
        url: `${AIPromptQueryUrl.GetAIPromptById}/${id}`,
        method: RequestType.GET,
    });

/**
 * Sistem promptlarını getirir (UI için)
 * @param params - Filtreleme parametreleri (category, modelType)
 */
export const GetSystemPrompts = (params?: { category?: string; modelType?: string }) =>
    request({
        url: `${AIPromptQueryUrl.GetSystemPrompts}`,
        method: RequestType.GET,
        params: params,
    });

/**
 * Aktif sistem promptlarını getirir (UI için)
 * @param params - Filtreleme parametreleri (category, modelType)
 */
export const GetActiveSystemPrompts = (params?: { category?: string; modelType?: string }) =>
    request({
        url: `${AIPromptQueryUrl.GetActiveSystemPrompts}`,
        method: RequestType.GET,
        params: params,
    });

